import POLVO_EXT_1 from "./POLVO_EXT_1";

export default {
  POLVO_EXT_1,
};
